module.exports = __webpack_public_path__ + "static/img/3.63986c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/eng/3.png
// module id = e/3e
// module chunks = 0